
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlertOffGoogle as ObiAlertOffGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alert-off-google.js';
 
 
 

 
 export const ObiAlertOffGoogle = createComponent({
   react: React,
   tagName: 'obi-alert-off-google',
   elementClass: ObiAlertOffGoogleElement,
   events: {
     
   }
  });
 
 